const getCookieValue = (name) => {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
};


const setCookie = (name, value, options = {}) => {

    let cookie = `${name}=${value};`;

    if (options.expires) {
        if (typeof options.expires === 'number') {
            const date = new Date();
            date.setTime(date.getTime() + options.expires * 1000);
            cookie += `expires=${date.toUTCString()};`;
        } else if (options.expires instanceof Date) {
            cookie += `expires=${options.expires.toUTCString()};`;
        }
    }

    if (options.path) {
        cookie += `path=${options.path};`;
    } else {
        cookie += 'path=/;';
    }


    const domain = options.domain || window.location.hostname.split('.').slice(-2).join('.');

    cookie += `domain=${domain ? domain : 'pouyanbroker.ir'};`;


    document.cookie = cookie;
};


const setFlagInCookie = (nationalId, flagValue) => {
    const cookieName = `flag_${nationalId}`;
    const cookieValue = flagValue ? "true" : "false";
    const expirationDate = new Date();
    expirationDate.setFullYear(expirationDate.getFullYear() + 1);
    document.cookie = `${cookieName}=${cookieValue}; expires=${expirationDate.toUTCString()}; path=/`;
}

 const clearCookies = () => {
    const cookies = document.cookie.split(";");
    const domain = window.location.hostname.split('.').slice(-2).join('.'); 
    
    cookies.forEach((cookie) => {
        const eqPos = cookie.indexOf("=");
        const name = eqPos > -1 ? cookie.substr(0, eqPos).trim() : cookie.trim();
        
        document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=${domain}`;
    });
}

export { setCookie, setFlagInCookie, getCookieValue , clearCookies };
